module.exports = __webpack_public_path__ + "static/NotoSansKR-Light-1b0504a3e741f8e6e07b297cb8f55d2d.otf";